import styles from "./skeletonPicture.module.scss";

interface SkeletonPictureProps {
  size: "sm" | "md" | "lg";
  isStatic?: boolean;
}

const SkeletonPicture: React.FC<SkeletonPictureProps> = ({
  size,
  isStatic,
}) => {
  const pictureSize = () => {
    switch (size) {
      case "sm":
        return styles.sm;
      case "md":
        return styles.md;
      case "lg":
        return styles.lg;
    }
  };

  return (
    <div
      data-testid="skeletonPicture"
      className={`${styles.picture} ${pictureSize()} ${
        isStatic ? styles.static : styles.animated
      }`}
    />
  );
};

export default SkeletonPicture;
